
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    PagesCoreFooter: () => import('./components/core/Footer.vue'),
    PagesCoreView: () => import('./components/core/View.vue'),
  },
})
export default class Index extends Vue {
  private created(): void {
    this.$vuetify.theme.dark = true;
  }
}
